module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Purchase Order Details")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto",
    attrs: {
      "center": ""
    }
  }, [_c('b-nav-form', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.goToMain
    }
  }, [_vm._v("New Purchase Order")])], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    staticClass: "gutr"
  }, [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.stockList,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "poOrderId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "poOrderSeries",
      fn: function(row1) {
        return [_c('span', {
          staticClass: "showMoreData",
          on: {
            "click": function($event) {
              _vm.viewPoPage(row1.item.poOrderId)
            }
          }
        }, [_vm._v(_vm._s(row1.item.poOrderSeries))])]
      }
    }, {
      key: "poDate",
      fn: function(row12) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("moment")(row12.item.poDate)))])]
      }
    }, {
      key: "loginTime",
      fn: function(row116) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("moment")(row116.item.loginTime)))])]
      }
    }, {
      key: "poOrder_pdf",
      fn: function(row14) {
        return [(row14.item.poOrder_pdf != null) ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-success"
          },
          on: {
            "click": function($event) {
              _vm.PrintNote(row14.item.poOrder_pdf)
            }
          }
        }, [_vm._v("PDF")]) : _c('span', [_vm._v("N/A")])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "5",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3393ed84","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/maintenance/poOrder/viewPoOrder.vue
// module id = 2511
// module chunks = 0